<template>
  <div id="premiumPlansBody">

    <plan v-for="(i, index) of isMobile?['1']:['1']" @mouseover="chosePlan({price: plans[i].price.toFixed(2), duration: plans[i].duration})"
          :selected="currentPlan.duration === plans[i].duration"
          :currentplan="plans[i]"
          :key="index"
          @click="startCheckout(currentPlan.duration)"
    ></plan>

  </div>

</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  name: "premiumPlans",
  components: {Plan: () => import(/* webpackPrefetch: true */ '@/components/plan.vue')},
  props: {
    paddle: Object
  },



  computed: {
    ...mapGetters('global', [
        'isMobile', 'profile'
    ])
  },

  methods: {
    ...mapActions('global', [
      'change_userData',
    ]),
    chosePlan(plan) {
      this.currentPlan = plan;
    },

    startCheckout(nbMonths) {
      if(!this.$isDebug) {
        fbq('track', 'Souscrire Clicked');
      }
      /*if(nbMonths === 6) {
        this.chosePlan({price: 44.99, duration: nbMonths})
      }
      else if(nbMonths === 3) {
        this.chosePlan({price: 29.99, duration: nbMonths})
      }
      else */
      if(nbMonths === 1) {
        this.chosePlan({price: 12.99, duration: nbMonths})
      }
      this.$emit('checkout', this.currentPlan)

    }

    /*
    buy: function(monthNb) {
      if(!this.$isDebug) {
        fbq('track', 'Souscrire Clicked');
      }
      if(monthNb === 3) {
        this.paddle.Checkout.open({
          product: 653306,
          passthrough: "{\"user_id\": \"" + this.profile.sub + "\", \"billing_type\": "+ monthNb +"}",
          email: this.profile.email,
          message: 'Bienvenu(e) sur Learn & Watch !',
          successCallback: () => {
            if(!this.$isDebug) {
              fbq('track', 'Subscribe', {value: '24.00', currency: 'EUR', predicted_ltv: '24.00'});
            }
            this.change_userOption({
              name: 'is_premium',
              value: true
            })
            this.$emit('sub');
          }
        })
      }
      else if(monthNb === 12) {
        this.paddle.Checkout.open({
          product: 653308,
          passthrough: "{\"user_id\": \"" + this.profile.sub + "\", \"billing_type\": "+ monthNb +"}",
          email: this.profile.email,
          message: 'Bienvenu(e) sur Learn & Watch !',
          successCallback: () => {
            if(!this.$isDebug) {
              fbq('track', 'Subscribe', {value: '36.00', currency: 'EUR', predicted_ltv: '36.00'});
            }
            this.change_userOption({
              name: 'is_premium',
              value: true
            })
            this.$emit('sub');
          }
        })
      }

    },*/
  },

  data() {
    return {
      plans: {
        /*'6': {
          duration: 6,
          price: 44.99,
          monthly: 7.50
        },
        '3': {
          duration: 3,
          price: 29.99,
          monthly: 10.00
        },*/
        '1': {
          duration: 1,
          price: 12.99,
          monthly: 12.99
        },
      },

      currentPlan: {
        duration: 1,
        price: 12.99,
      },
      paddleLoaded: false
    }
  }
}
</script>

<style scoped>
#titlePremiumPlans{
  grid-column: 1/3; grid-row: 1/2;
}

  #premiumPlansBody{
    display: grid;
    grid-auto-flow: row;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr;
    width:calc(95% - 2vw);
    grid-column-gap: 1vw;
    grid-row-gap: 1vw;
    text-align: center;
    padding: 1vw;
  }

  .selected{
    z-index: 1;
    /*border: 0.2vw solid #3b49a5;*/
    transform: scale(1.1)
  }

  .subscribe{
    margin: 1vw;
    margin-left: auto;
    margin-right: auto;
    transition: transform 0.25s;
  }

  @media screen and (max-device-width: 767px) {
    #titlePremiumPlans{
      grid-column: 1/2; grid-row: 1/2;
    }

    #premiumPlansBody{
      grid-template-rows: 1fr 1fr;
      grid-template-columns: 1fr 1fr;
      width:calc(100% - 2vw);
      grid-auto-flow:column;
      grid-column-gap: 9vw;
      grid-row-gap: 2vw;
      text-align: center;
    }

  }


</style>
